import {Link} from 'react-router-dom';
import AurEcaSearchLoader from '../../../common/aur-eca-search-loader/AurEcaSearchLoader';
import {useState} from 'react';
import AurButton from '../../../common/aur-button/AurButton';

const EcaSearchLoader: React.FC = () => {
  const [showLoader, setShowLoader] = useState(false);
  return (
    <div style={{marginBottom: '64px'}}>
      <h1>Eca Search Loader</h1>
      <div>
        Loader modal for ECA Search with progress animation which updates after
        every 20 seconds.
      </div>
      <Link to="/demo">Return</Link>
      <hr />
      <AurButton
        type="continue"
        label={'Show Loader'}
        size="Large"
        onClick={() => {
          setShowLoader(true);
        }}
      />
      <br />
      <br />
      <div style={{marginBottom: '32px'}}>
        {showLoader && (
          <AurEcaSearchLoader
            isOpen={showLoader}
            keepMounted
            onClose={() => setShowLoader(false)}
          />
        )}
      </div>
    </div>
  );
};

export default EcaSearchLoader;
